import { Grid } from "@mui/material";
import { Control, useWatch } from "react-hook-form";
import { General } from "../../../types/brochure";
import { ControlledTextField } from "../fields/ControlledTextField";
import {
  getInputAlternativesHelperText,
  inputDirectiveTooltip,
  inputValidator,
} from "../../../utils/forms.utils";

export const GeneralForm = ({ control }: { control: Control<General> }) => {
  const input = useWatch({ control, name: "input" });
  const inputHelperText = getInputAlternativesHelperText(input ?? "");
  return (
    <>
      <Grid item xs={12}>
        <ControlledTextField
          field="input"
          control={control}
          rules={{ validate: inputValidator }}
          tooltip={inputDirectiveTooltip}
          helperText={inputHelperText}
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField field="name" control={control} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField field="text" control={control} />
      </Grid>
    </>
  );
};
